<template>
  <section id="silhouette" class="c__section section__variety">
    <div class="c__container">
      <div class="c__headblock">
        <h2 class="c__leadcopy navy c__no__anm"> 着心地に合わせて<br />シルエットをえらぼう </h2>
        <p class="navy c__bodycopy c__no__anm">
          パジャマ型、プルオーバー型、ワンピース型の中から、<br />あなたに合ったものを選びましょう。
        </p>
      </div>
      <div class="variety__height__01 height"></div>
      <div class="variety__height__02 height"></div>
      <div class="variety__height__03 height"></div>
      <div class="variety__height__04 height"></div>
      <div class="variety__height__05 height"></div>
      <div class="variey__img">
        <div class="variety__01">
          <AtomsConsumerLink url="/night-conditioning/recovery-wear?silhouette=button-front">
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/variety_01.jpg"
              alt="パジャマ"
              :width="809"
              :height="1081"
            />
          </AtomsConsumerLink>
          <AtomsConsumerLink url="/night-conditioning/recovery-wear?silhouette=button-front" class="variey__link">
            <p>商品を見る</p>
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
              alt="arrow"
              :width="10"
              :height="8"
            />
          </AtomsConsumerLink>
        </div>
        <div class="variety__02">
          <AtomsConsumerLink url="/night-conditioning/recovery-wear?silhouette=pullover">
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/variety_02.jpg"
              alt="プルオーバー"
              :width="809"
              :height="1081"
            />
          </AtomsConsumerLink>
          <AtomsConsumerLink url="/night-conditioning/recovery-wear?silhouette=pullover" class="variey__link">
            <p>商品を見る</p>
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
              alt="arrow"
              :width="10"
              :height="8"
            />
          </AtomsConsumerLink>
        </div>
        <div class="variety__03">
          <AtomsConsumerLink url="/night-conditioning/recovery-wear?silhouette=one-piece">
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/variety_03.jpg"
              alt="ワンピース"
              :width="809"
              :height="1081"
            />
          </AtomsConsumerLink>
          <AtomsConsumerLink url="/night-conditioning/recovery-wear?silhouette=one-piece" class="variey__link">
            <p>商品を見る</p>
            <AtomsConsumerImage
              src="/images/site/feature/howtochoose_recoverywear_sleepitem/arrow-blue.svg"
              alt="arrow"
              :width="10"
              :height="8"
            />
          </AtomsConsumerLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

onMounted(() => {
  gsap.to(".section__variety .c__headblock", {
    autoAlpha: 0,
    scrollTrigger: {
      trigger: ".variety__height__01",
      start: "top 50%",
      end: "bottom top",
      toggleActions: "play reverse play reverse",
      scrub: true,
    },
  })

  ScrollTrigger.matchMedia({
    "(min-width: 1025px)": function () {
      gsap.to(".variety__01", {
        transform: "translateY(-42rem)",
        scrollTrigger: {
          trigger: ".variety__height__01",
          start: "top bottom",
          end: "bottom top",
          toggleActions: "play reverse play reverse",
          scrub: 0.1,
          anticipatePin: 1,
          fastScrollEnd: true,
        },
      })

      gsap.to(".variety__02", {
        transform: "translateY(-42rem)",
        scrollTrigger: {
          trigger: ".variety__height__02",
          start: "top bottom",
          end: "bottom top",
          toggleActions: "play reverse play reverse",
          scrub: 0.1,
          anticipatePin: 1,
          fastScrollEnd: true,
        },
      })

      gsap.to(".variety__03", {
        transform: "translateY(-42rem)",
        scrollTrigger: {
          trigger: ".variety__height__03",
          start: "top bottom",
          end: "bottom top",
          toggleActions: "play reverse play reverse",
          scrub: 0.1,
          anticipatePin: 1,
          fastScrollEnd: true,
        },
      })
    },
  })

  gsap.matchMedia().add("(min-width: 1025px)", () => {
    gsap.to(".section__variety", {
      autoAlpha: 0,
      scrollTrigger: {
        trigger: ".variety__height__05",
        start: "bottom 30%",
        end: "bottom top",
        toggleActions: "play reverse play reverse",
        scrub: true,
      },
    })
  })
})

onUnmounted(() => {
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
})
</script>

<style scoped lang="scss">
@import "assets/scss/pages/howtochoose_recoverywear_sleepitem/main";
</style>
